export default "__VITE_ASSET__kbJzxJyq__"